(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('prop-types')) :
	typeof define === 'function' && define.amd ? define(['react', 'prop-types'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global["dist/index"] = global["dist/index"] || {}, global["dist/index"].js = factory(global.React, global.PropTypes)));
})(this, (function (React, PropTypes) { 'use strict';

	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

	var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
	var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

	var classnames = {exports: {}};

	/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/

	(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames() {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}

					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}());
	}(classnames));

	var classNames = classnames.exports;

	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;

	  if (!css || typeof document === 'undefined') {
	    return;
	  }

	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';

	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }

	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}

	var css_248z = "/* Consolidation of frequently used colours throughout the repo */\n.responsive_navigationtab_container {\n  display: flex;\n  align-items: stretch;\n  position: static;\n  min-width: 60rem;\n  max-height: 80vh;\n  height: 100%;\n  z-index: 1;\n  flex-direction: column;\n}\n.responsive_navigationtab_container .responsive_navigationtab {\n  display: flex;\n  flex-grow: 1;\n}\n.responsive_navigationtab_container .responsive_navigationtab ul {\n  width: 100%;\n  display: flex;\n}\n.responsive_navigationtab_container .responsive_navigationtab ul li {\n  margin-top: 0;\n  padding: 0.875rem 1.875rem;\n  cursor: pointer;\n  margin-right: -3px;\n  border-left: 5px solid transparent;\n  font-size: 1.125rem;\n  line-height: 2.5;\n  background-color: #eeeeee;\n  margin-bottom: 1rem;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.responsive_navigationtab_container .responsive_navigationtab ul li.disabled {\n  cursor: none;\n}\n.responsive_navigationtab_container .responsive_navigationtab ul li.active {\n  color: #ffffff;\n  background-color: #051d33;\n}\n.responsive_navigationtab_container .responsive_navigationtab ul li.active:first-child {\n  border-radius: 0.5rem 0 0 0.5rem;\n}\n.responsive_navigationtab_container .responsive_navigationtab ul li.active:last-child {\n  border-radius: 0 0.5rem 0.5rem 0;\n}\n.responsive_navigationtab_container .responsive_navigationtab_body {\n  display: flex;\n  flex-grow: 4;\n  position: relative;\n  padding: 2rem;\n  display: flex;\n  align-items: flex-start;\n  background: #ffffff;\n}\n.responsive_navigationtab_container .responsive_navigationtab_body > div {\n  margin-right: auto;\n  margin-left: auto;\n  width: 100%;\n}";
	styleInject(css_248z);

	/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
	var getActiveTabState = function (options, activeTab) {
	    return options.hasOwnProperty(activeTab) ? activeTab : Object.keys(options)[0];
	};
	var NavigationTab = function (_a) {
	    var _b;
	    var _c = _a.hideTabForSingleItem, hideTabForSingleItem = _c === void 0 ? false : _c, // Hide the navigation tab when there is only one item
	    _d = _a.activeTabListener, // Hide the navigation tab when there is only one item
	    activeTabListener = _d === void 0 ? function () { return null; } : _d, options = _a.options, activeTab = _a.activeTab, history = _a.history;
	    var itemList = Object.keys(options);
	    if (!itemList.length) {
	        return React__default["default"].createElement("div", null);
	    }
	    var _e = React.useState(getActiveTabState(options, activeTab)), activeTabState = _e[0], setActiveTabState = _e[1];
	    var handleOptionSelected = function (val) {
	        var _a;
	        if (!((_a = options[val]) === null || _a === void 0 ? void 0 : _a.isTabDisabled)) {
	            activeTabListener(val);
	            setActiveTabState(val);
	        }
	    };
	    React.useEffect(function () {
	        var _a, _b;
	        var params = new URLSearchParams((_b = (_a = history === null || history === void 0 ? void 0 : history.location) === null || _a === void 0 ? void 0 : _a.search) !== null && _b !== void 0 ? _b : '');
	        if (params.has('activeTab')) {
	            var tempActiveTab = params.get('activeTab');
	            if (tempActiveTab && tempActiveTab in options) {
	                handleOptionSelected(tempActiveTab);
	            }
	        }
	    }, []);
	    React.useEffect(function () {
	        handleOptionSelected(getActiveTabState(options, activeTab));
	    }, [activeTab]);
	    var keyDownHandler = function (event, val) {
	        if (event.key === 'Enter') {
	            handleOptionSelected(val);
	        }
	    };
	    return (React__default["default"].createElement("div", { className: 'responsive_navigationtab_container' },
	        (!hideTabForSingleItem || itemList.length > 1) && (React__default["default"].createElement("div", { className: 'responsive_navigationtab' },
	            React__default["default"].createElement("ul", null, itemList.map(function (val) {
	                var _a, _b, _c;
	                return (React__default["default"].createElement("li", { onClick: function () { return handleOptionSelected(val); }, className: classNames({
	                        active: activeTabState === val,
	                        disabled: (_a = options[val]) === null || _a === void 0 ? void 0 : _a.isTabDisabled,
	                    }), key: val, onKeyDown: function (event) {
	                        return keyDownHandler(event, val);
	                    }, tabIndex: 0, title: ((_b = options[val]) === null || _b === void 0 ? void 0 : _b.isTabDisabled) ? '' : options[val].title }, ((_c = options[val]) === null || _c === void 0 ? void 0 : _c.children) || options[val].title));
	            })))),
	        React__default["default"].createElement("div", { className: 'responsive_navigationtab_body' }, (_b = options[activeTabState]) === null || _b === void 0 ? void 0 : _b.comp)));
	};
	NavigationTab.defaultProps = {
	    activeTabListener: function () { return null; },
	    hideTabForSingleItem: false,
	};
	NavigationTab.propTypes = {
	    options: PropTypes__default["default"].objectOf(PropTypes__default["default"].shape({
	        comp: PropTypes__default["default"].any.isRequired,
	        title: PropTypes__default["default"].string.isRequired,
	        children: PropTypes__default["default"].any,
	        isTabDisabled: PropTypes__default["default"].bool,
	    }).isRequired).isRequired,
	    hideTabForSingleItem: PropTypes__default["default"].bool,
	    history: PropTypes__default["default"].shape({
	        location: PropTypes__default["default"].shape({
	            search: PropTypes__default["default"].string.isRequired,
	        }).isRequired,
	    }).isRequired,
	    activeTab: PropTypes__default["default"].string.isRequired,
	    activeTabListener: PropTypes__default["default"].func,
	};

	return NavigationTab;

}));
